import {Input} from 'react-bootstrap'
import React from 'react'
import {t} from '../../helpers/translate'
import StaticTextComponent from './StaticTextComponent'
import BaseInputComponent from './BaseInputComponent'

class HiddenComponent extends BaseInputComponent {
   constructor(props) {
    super(props);
  }

  render() {
     return <div className={`form-group ${this.state.isInvalid ? 'has-error' : ''}`}>
        <input id={this.state.id} type="hidden" value={this.state.value || 'ingle'} onChange={(event) => {this.handleChange(event.target.value)}}/>
     </div>
  }
}
HiddenComponent.displayName = 'HiddenComponent';
export default HiddenComponent;



// WEBPACK FOOTER //
// ./src/components/common/HiddenComponent.js